import DocPackageService from '@/services/bytepro/docPackage.service';

export const docPackage = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    get({ commit }, fileDataId){
      return DocPackageService.get(fileDataId).then(
        resp => {
          commit('dummy', "get - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "get - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    }
  }
};